import React from 'react';

import { SVGPropsType } from 'src/types';

function BarChart(props: SVGPropsType) {
    const { stroke, onClick, style, className } = props;

    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            onClick={onClick}
            style={style}
            className={className}
        >
            <path
                d="M4.6001 2.40002V13.7"
                stroke={stroke}
                strokeWidth="1.2"
                strokeMiterlimit="10"
            />
            <path
                d="M6.9001 4.90002H4.6001"
                stroke={stroke}
                strokeWidth="1.2"
                strokeMiterlimit="10"
            />
            <path d="M4.6002 10.8H2.2002" stroke={stroke} strokeWidth="1.2" strokeMiterlimit="10" />
            <path
                d="M11.4001 7.70001H9.1001"
                stroke={stroke}
                strokeWidth="1.2"
                strokeMiterlimit="10"
            />
            <path
                d="M13.7999 11.7H11.3999"
                stroke={stroke}
                strokeWidth="1.2"
                strokeMiterlimit="10"
            />
            <path
                d="M11.3999 2.40002V13.7"
                stroke={stroke}
                strokeWidth="1.2"
                strokeMiterlimit="10"
            />
        </svg>
    );
}

export default BarChart;
